export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_ar.06fb918541d68ed5.json"